import React from 'react';

import {
  Box,
  Stepper as MuiStepper,
  Skeleton,
  Step,
  stepConnectorClasses,
  stepContentClasses,
} from '@mui/material';

import { Nullable } from '@clearverify/types';

import { useActivityLogsByInboxItemId } from 'src/hooks/activityLog';
import { SxProp } from 'src/types/mui';

import { ActivityLogItem } from './ActivityLogItem';

interface ActivityLogsListProps {
  inboxItemId: Nullable<string>;
  /** Employer / PEO / PEO PP view of a Verification Request: the server sends generic headings
   * with no author or company, so the entries render without the identity sub-text. */
  sanitized?: boolean;
}

export const ActivityLogsList: React.FC<ActivityLogsListProps> = ({ inboxItemId, sanitized }) => {
  const { activityLogs, loading } = useActivityLogsByInboxItemId(inboxItemId);

  if (!activityLogs && loading) {
    return (
      <Box>
        <Skeleton variant="rectangular" width="100%" height={40} />
      </Box>
    );
  }

  return (
    <MuiStepper orientation="vertical" sx={stepperStyles}>
      {activityLogs?.map(activityLog => {
        return (
          <Step active key={activityLog.id}>
            <ActivityLogItem activityLog={activityLog} sanitized={sanitized} />
          </Step>
        );
      })}
    </MuiStepper>
  );
};

const stepperStyles: SxProp = {
  [`.${stepConnectorClasses.line}`]: {
    minHeight: '10px',
  },
  [`.${stepContentClasses.root}`]: {
    paddingLeft: '30px',
    paddingRight: 0,
  },
};
